import React, { useState, useEffect } from 'react';
import './App.css';
import LandingPage from './components/LandingPage';
import JourneyConfigForm from './components/JourneyConfigForm';
import JourneyDetail from './components/JourneyDetail';
import JourneyConfigDetail from './components/JourneyConfigDetail';
import JourneysList from './components/JourneysList';
import LoginForm from './components/LoginForm';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import ProfilePage from './components/ProfilePage';

function App() {
  // DEV MODE: Use demo token if no token exists (bypass login)
  const storedToken = localStorage.getItem('token');
  const demoToken = 'demo-token-dev-mode';
  const DEMO_USER_ID = 'f47ac10b-58cc-4372-a567-0e02b2c3d479';

  const [token, setToken] = useState(storedToken || null);
  const [userId, setUserId] = useState(localStorage.getItem('userId') || null);
  const [userName, setUserName] = useState(localStorage.getItem('userName') || null);
  const [currentPage, setCurrentPage] = useState('config'); // 'config', 'list', 'detail', or 'journey'
  const [selectedConfigId, setSelectedConfigId] = useState(null);
  const [selectedJourneyData, setSelectedJourneyData] = useState(null);

  const handleLoginSuccess = (newToken, newUserId, newUserName) => {
    setToken(newToken);
    setUserId(newUserId);
    setUserName(newUserName);
    localStorage.setItem('token', newToken);
    localStorage.setItem('userId', newUserId);
    localStorage.setItem('userName', newUserName);
  };

  const handleLogout = () => {
    setToken(null);
    setUserId(null);
    setUserName(null);
    setCurrentPage('config');
    setSelectedConfigId(null);
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
  };

  const handleNavigateToJourney = (configId) => {
    setSelectedConfigId(configId);
    setCurrentPage('journey');
  };

  const handleBackToConfig = () => {
    setCurrentPage('config');
    setSelectedConfigId(null);
  };

  const handleNavigateToList = () => {
    setCurrentPage('list');
  };

  const handleBackFromList = () => {
    setCurrentPage('config');
  };

  const handleSelectFromList = (configId, journeyData) => {
    setSelectedConfigId(configId);
    setSelectedJourneyData(journeyData);
    setCurrentPage('detail');
  };

  const handleBackFromDetail = () => {
    setCurrentPage('list');
    setSelectedConfigId(null);
    setSelectedJourneyData(null);
  };

  const handleActivateFromDetail = (configId) => {
    setSelectedConfigId(configId);
    setCurrentPage('journey');
  };

  // Decode JWT to get user role
  const getUserRole = () => {
    if (!token) return null;
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      const decoded = JSON.parse(jsonPayload);
      return decoded.role;
    } catch (err) {
      return null;
    }
  };

  const userRole = getUserRole();

  // If user is admin, show admin dashboard
  if (userRole === 'admin') {
    return (
      <div className="App admin-mode">
        {!token ? (
          <LandingPage onLoginSuccess={handleLoginSuccess} />
        ) : (
          <AdminDashboard
            token={token}
            userId={userId}
            userName={userName}
            userRole={userRole}
            onLogout={handleLogout}
          />
        )}
      </div>
    );
  }

  // If user is facilitator or contributor, show dashboard
  if (userRole === 'facilitator' || userRole === 'contributor') {
    return (
      <div className="App facilitator-mode">
        {!token ? (
          <LandingPage onLoginSuccess={handleLoginSuccess} />
        ) : (
          <Dashboard
            token={token}
            userId={userId}
            userName={userName}
            userRole={userRole}
            onLogout={handleLogout}
          />
        )}
      </div>
    );
  }

  return (
    <div className="App">
      {!token ? (
        <LandingPage onLoginSuccess={handleLoginSuccess} />
      ) : (
        <div className="container">
          <header className="header">
            <h1>Innovation Journey</h1>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </header>

          {currentPage === 'config' ? (
            <JourneyConfigForm
              token={token}
              userId={userId}
              onStartJourney={handleNavigateToJourney}
              onViewAllJourneys={handleNavigateToList}
            />
          ) : currentPage === 'list' ? (
            <JourneysList
              token={token}
              userRole={userRole}
              onBack={handleBackFromList}
              onSelectJourney={handleSelectFromList}
            />
          ) : currentPage === 'detail' ? (
            <JourneyConfigDetail
              configId={selectedConfigId}
              journeyData={selectedJourneyData}
              token={token}
              onBack={handleBackFromDetail}
              onActivate={handleActivateFromDetail}
            />
          ) : (
            <JourneyDetail
              configId={selectedConfigId}
              token={token}
              onBack={handleBackToConfig}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default App;
